import { ON_TRIGGER_GAME } from '../state-constants/stateConstants';

export const onTriggerGame = (level) => ({
  type: ON_TRIGGER_GAME,
  payload: level,
});



// WEBPACK FOOTER //
// ./src/state-actions/onTriggerGame.js